<template>
    <Header/>
    <div>
      <!-- hero area start -->
      <section class="hero-area app-slider pos-rel full-height d-flex align-items-center parallax" id="home" data-speed="3" data-bg-image="static/picture/slider-bg3.jpg">
        <div class="slider_overlay"></div>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-8">
              <div class="hero-content">
                <h2>{{ $tm('banner.text1') }}</h2>
                <h3>{{ $tm('banner.text2') }}</h3>
                <p v-html="$tm('banner.text3')"></p>
                <a class="single-download-links" :href="downloadUrl" target="_blank">
                  <div class="sdl-icon">
                    <i class="fa fa-android"></i>
                  </div>
                  <div class="sdl-content">
                    <p>{{ $tm('banner.downloadButton') }}</p>
                    <h4>Android</h4>
                  </div>
                </a>
                <a class="single-download-links" :href="'https://peq.szwalkplay.com?lang=' + tm('lang') " target="_blank" style="margin-left: 20px;">
                  <div class="sdl-content" style="line-height: 46px;text-align: center;font-size: 24px; width: 100%;color: #545454;">
                    {{ tm('eqControlName') }}
                  </div>
                </a>
              </div>
            </div>
            <div class="col-md-4">
              <div class="screen-slides-area">
                <img src="static/picture/mobile-mockup.png" alt="image">
                <div class="screen-slides swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img src="static/picture/screen1.png" alt="image">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a href="#app-feature" class="scrl_me_down">
          <span class="fa fa-angle-down"></span>
        </a>
      </section>
      <!-- hero area end -->
      <!-- service area start -->
      <div id="app-feature" class="service-area pt--70 pb--100">
        <div class="container">
          <div class="row">

            <div class="col-md-4" v-for="item in $tm('feature')">
              <div class="single-service">
                <div class="icon">
                  <i :class="'fa ' + item.icon"></i>
                </div>
                <h4>{{ item.title }}</h4>
                <p>{{ item.content }}</p>
              </div>
            </div>

            <!-- <div class="col-md-4">
              <div class="single-service">
                <div class="icon">
                  <i class="fa fa-laptop"></i>
                </div>
                <h4>容易使用</h4>
                <p>界面直观，指引明确，操作步骤简化，自带预设EQ进行选择使用</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-service">
                <div class="icon">
                  <i class="fa fa-trophy"></i>
                </div>
                <h4>设计优秀</h4>
                <p>不仅美观而且相应速度快，实时试听调试效果。自适应各种设备尺寸，图标设计和动画和谐统一，并具有云端存储功能</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-service">
                <div class="icon">
                  <i class="fa fa-money"></i>
                </div>
                <h4>完全免费</h4>
                <p>无需支付任何费用即可下载使用</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- service area end -->
      <!-- appfeature area strat -->
      <section class="app-feature-area ptb--100" id="feature">
        <div class="container">
          <div class="h5-title section-title">
            <span>{{ $tm('explain.topTitle') }}</span>
            <h2>{{ $tm('explain.title') }}</h2>
          </div>
          <div class="row">
            <div class="d-none d-lg-block col-lg-4 order-lg-1">
              <div class="ft-device">
                <img src="static/picture/mobile-mockup2.png" alt="image">
              </div>
            </div>
            <div class="col-md-6 col-lg-4 order-lg-0">
              <div v-for="item in $tm('explain.list1')" class="feature-item">
                <div class="icon">
                  <i :class="'fa ' + item.icon"></i>
                </div>
                <div class="content">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.content }}</p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 order-lg-2 right-side">
              <div v-for="item in $tm('explain.list2')" class="feature-item">
                <div class="icon">
                  <i :class="'fa ' + item.icon"></i>
                </div>
                <div class="content">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- appfeature area end -->
      <!-- app-download area start -->
      <section class="adv2-section" id="download">
        <div class="container">
          <div class="adv2-header">
            <h2>{{ $tm('download.title') }}</h2>
            <p>{{ $tm('download.subTitle') }}</p>
          </div>
          <div class="adv2-cards">
            <!-- Android -->
            <div class="adv2-card">
              <div class="adv2-card-body">
                <div class="adv2-qr">
                  <img src="@/assets/app-download-qrcode.png" alt="android">
                </div>
                <div class="adv2-info">
                  <div class="adv2-plat-title">
                    <img src="@/assets/android-logo-green.png" alt="android">
                    <span>{{ $tm('download.android.title') }}</span>
                  </div>
                  <p>{{ $tm('download.android.desc1') }}</p>
                  <p>{{ $tm('download.android.desc2') }}</p>
                  <a class="adv2-btn" :href="downloadUrl" target="_blank">
                    <i class="fa fa-download"></i> {{ $tm('download.android.btn') }}
                  </a>
                </div>
              </div>
              <img class="adv2-store-logos" src="@/assets/android-store-logo-list.png" alt="stores">
            </div>
            <!-- iOS -->
            <div class="adv2-card adv2-ios-card">
              <div class="adv2-card-body">
                <div class="adv2-appstore-icon">
                  <img src="@/assets/apple-logo-icon.png" alt="App Store">
                </div>
                <div class="adv2-info">
                  <div class="adv2-plat-title">
                    <img src="@/assets/ios-logo-wite.png" alt="ios">
                    <span  style="margin-top: 20px;">{{ $tm('download.ios.title') }}</span>
                  </div>
                  <p style="margin-top: 20px;">{{ $tm('download.ios.desc') }}</p>
                </div>
              </div>
              <a href="https://apps.apple.com/cn/app/walk-play/id6769667401" target="_blank">
                <img class="adv2-ios-actions" src="@/assets/ios-search-download-btn.png" alt="App Store">
              </a>
            </div>
          </div>
        </div>
      </section>
      <!-- app-download area end -->

      <!-- contact area start -->
      <section class="contact-area h5-contact bg-gray ptb--100" id="contact">
        <div class="container">
          <div class="h5-title section-title">
            <span>{{ $tm('contact.topTitle') }}</span>
            <h2>{{ $tm('contact.title') }}</h2>
          </div>

		<!-- <div class="row align">
			<div class="col-md-12" style="text-align: center;font-size:2rem;">
				 <a style="font-size:2rem;" href="mailto:service@szwalkplay.com">service@szwalkplay.com</a>
			</div>
		</div> -->
          <div class="row align">
            <div class="col-md-6">
              <div class="contact-content cnt-form">
                <form action="" method="post" onsubmit="return false;">
                  <div class="row">
                    <div class="col-md-6">
                      <input type="text" :placeholder="$tm('contact.table.name')" v-model="form.name">
                    </div>
                    <div class="col-md-6">
                      <input type="email" :placeholder="$tm('contact.table.email')"  v-model="form.email">
                    </div>
                    <div class="col-md-12">
                      <textarea  v-model="form.message" id="msg" :placeholder="$tm('contact.table.leaveMsg')"></textarea>
                    </div>
                    <div class="col-12">
                      <input type="submit" name="send" :value="$tm('contact.button')" @click="sm">
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="col-md-6">
              <div id="google_map"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
      
    <ImageVCode ref="ImageVCode" :callback="imageVCodeCallback" :show="imageVCodeShow" :closeCallback="closeImageVCode"/>
  <Footer/>
  </template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ImageVCode from '@/components/ImageVCode.vue';
import { useI18n } from 'vue-i18n';
import { submitMessage } from '@/api/home';
import { getApiLatestVersion } from '@/api/common';

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    ImageVCode
  },
  data(){
    return {
      lang: 'zh',
      tm: null,
      imageVCodeShow: false,
      downloadUrl: null,
      form: {
        lang: 'zh',
        name: null,
        email: null,
        message: null,
        uuid: null
      }
    }
  },
  created(){
    document.title = 'Walk Play';
    const { tm, locale } = useI18n();
    this.tm = tm;
    this.getDownloadUrl();
  },
  methods:{
    getDownloadUrl(){
      getApiLatestVersion().then(res => {
        if(res.code == 0){
          this.downloadUrl = res.data.URL;
        }
      });
      // this.downloadUrl = '/apk/WalkPlay_v2.1.3_release_2130_0111.apk';
    },
    sm(){
      const form = this.form;
      const tm = this.tm;

      if(!form.name || form.name == ''){
        alert(tm('contactFormAction.remind1'));
        return;
      }
      if(!form.email || form.email == ''){
        alert(tm('contactFormAction.remind2'));
        return;
      }
      if(!form.message || form.message == ''){
        alert(tm('contactFormAction.remind4'));
        return;
      }

      this.imageVCodeShow = true;
    },
    imageVCodeCallback(uuid, val, updateCallback){
      if(uuid && val){
        this.form.code = val;
        this.form.uuid = uuid;
        submitMessage(this.form).then(res => {
          console.log(res)
          if(res.code == 0){
            alert(this.tm('contactFormAction.commitSuccessful'));
            this.imageVCodeShow = false;
          }else{
            updateCallback();
          }
        })
      }
    },
    closeImageVCode(){
      this.imageVCodeShow = false;
    }
    
  }
}
</script>

<style scoped>
.adv2-section {
  width: 100%;
  min-height: 600px;
  background: #0b1d6e url('@/assets/app-download-bg.png') center/cover no-repeat;
  padding: 80px 0;
}
.adv2-header {
  text-align: center;
  color: #fff;
  margin-bottom: 48px;
}
.adv2-header h2 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #fff;
}
.adv2-header p {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255,255,255,0.6);
  text-align: center;
}
.adv2-cards {
  display: flex;
  gap: 28px;
  margin-top: 100px;
}
.adv2-card {
  flex: 1;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 16px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.adv2-card-body {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
.adv2-qr {
  width: 148px;
  height: 148px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  background-size: 100% 100%, 9px 9px, 9px 9px;
}
.adv2-qr img {
  width: 90%;
  height: 90%;
  margin: 5%;
  object-fit: cover;
}
.adv2-info {
  flex: 1;
  color: #fff;
}
.adv2-plat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.adv2-plat-title img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.adv2-plat-title span {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}
.adv2-info p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255,255,255,0.7);
  margin: 0 0 4px;
  line-height: 1.5;
}
.adv2-btn {
  display: block;
  width: 382px;
  height: 42px;
  line-height: 42px;
  margin-top: 14px;
  padding: 0;
  text-align: center;
  background: linear-gradient(90deg, #3a8ef6, #7c5af0);
  border-radius: 8px;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
  text-decoration: none;
}
.adv2-btn:hover { opacity: 0.9; color: #fff; }
.adv2-store-logos {
  width: 560px;
  height: 54px;
  display: block;
  object-fit: contain;
}
.adv2-appstore-icon {
  width: 132px;
  height: 132px;
  flex-shrink: 0;
  border-radius: 28px;
  background: linear-gradient(145deg, #28a8e0, #0055cc);
  display: flex;
  align-items: center;
  justify-content: center;
}
.adv2-ios-card .adv2-plat-title {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.adv2-appstore-icon span {
  font-size: 2.4rem;
  font-weight: 300;
  color: #fff;
  font-style: italic;
}
.adv2-ios-actions {
  width: 440px;
  margin-top: 20px;
}
</style>
